const KNOWN_AGENT_DISPLAY_NAMES: Record<string, string> = {
  openai: "OpenAI",
  chatgpt: "ChatGPT",
  anthropic: "Anthropic",
  claude: "Claude",
  copilot: "Copilot",
  githubcopilot: "GitHub Copilot",
  cursor: "Cursor",
  gemini: "Gemini",
  google: "Google",
  googleai: "Google AI",
  meta: "Meta",
  llama: "LLaMA",
  mistral: "Mistral",
  perplexity: "Perplexity",
  grok: "Grok",
  xai: "xAI",
  deepseek: "DeepSeek",
  ollama: "Ollama",
  langchain: "LangChain",
  huggingface: "Hugging Face",
  azureopenai: "Azure OpenAI",
  bedrock: "Amazon Bedrock",
  amazonbedrock: "Amazon Bedrock",
  awsbedrock: "AWS Bedrock",
  midjourney: "Midjourney",
  cohere: "Cohere",
  windsurf: "Windsurf",
  codeium: "Codeium",
  tabnine: "Tabnine",
  replit: "Replit",
  phind: "Phind",
  youcom: "You.com",
  pi: "Pi",
  inflection: "Inflection",
  character: "Character",
  characterai: "Character.AI",
  jan: "Jan",
  lmstudio: "LM Studio",
  continue: "Continue",
  aider: "Aider",
  cody: "Cody",
  sourcegraph: "Sourcegraph",
  jetbrains: "JetBrains",
  amazonq: "Amazon Q",
  amazon: "Amazon",
};

function formatToken(token: string): string {
  const lower = token.trim().toLowerCase();
  if (!lower) return "";

  const known = KNOWN_AGENT_DISPLAY_NAMES[lower];
  if (known) return known;

  if (lower.endsWith("ai") && lower.length > 2) {
    const prefix = lower.slice(0, -2);
    if (prefix) {
      return prefix.charAt(0).toUpperCase() + prefix.slice(1) + "AI";
    }
  }

  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export function formatAgentDisplayName(agentKey?: string | null): string {
  if (!agentKey?.trim()) return "";

  const trimmed = agentKey.trim();
  const lower = trimmed.toLowerCase();
  const known = KNOWN_AGENT_DISPLAY_NAMES[lower];
  if (known) return known;

  if (/[-_\s]/.test(trimmed)) {
    return trimmed
      .split(/[-_\s]+/)
      .filter(Boolean)
      .map(formatToken)
      .join(" ");
  }

  return formatToken(trimmed);
}
